import date from './date.js'
import implode from './implode.js'
import count from './count.js'
import strtotime from './strtotime.js'
import array_sum from './array_sum.js'
import empty from './empty.js'
import str_replace from './str_replace.js'
import isset from './isset.js'
import sprintf from './sprintf.js'
import in_array from './in_array.js'
import setFormatTime from './setFormatTime.js'
import filterRequestResult from './filterRequestResult.js'
import filterResult from './filterResult.js'
import array_merge from './array_merge.js'
import is_string from './is_string.js'
import isArray from './isArray.js'

var lib = {
	date: date,
	count: count,
	strtotime: strtotime,
  is_string: is_string,
	array_sum: array_sum,
	empty: empty,
	implode: implode,
	in_array: in_array,
	isset: isset,
  sprintf: sprintf,
  array_merge: array_merge,
  filterRequestResult: filterRequestResult,
  filterResult: filterResult,
  setFormatTime: setFormatTime,
  isArray: isArray,
	str_replace: str_replace
}

export default lib




// WEBPACK FOOTER //
// ./src/assets/js/lib/index.js